export default __webpack_public_path__ + "static/media/omni.89615c96.png";